import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
// import "./vehiclelist.css";
import back from "../../../assets/svg/backarrow.svg";
import search from "../../../assets/svg/search.svg";
import plus from "../../../assets/svg/plus.svg";
import edit from "../../../assets/svg/edit.svg";
import del from "../../../assets/svg/delete.svg";
import close from "../../../assets/svg/close.svg";
import ReactPaginate from "react-paginate";
import df from "../../../assets/svg/df.svg";
import SearchWithAPI from "../../searchbox/searchbox.js";
// import VehicleAdd from "./vehicleadd";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import lar from "../../../assets/svg/lar.svg";
import rar from "../../../assets/svg/rar.svg";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DeleteModal from "../../common/delete-modal.js";
import mawalog from "../../../assets/svg/mawaloglogo.svg";
import {
  getProductListApi,
  getTransporterListApi,
} from "../customers/customer-api.js";
import ProductCreateModal from "./product-add.js";
import CustomerTabs from "../set-bar.js";
import CustomerButtons from "../excel-upload-download.js";
export default function ProductType() {
  //default dropdown
  const [selectedValue, setSelectedValue] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortDir, setSortDir] = useState("");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [povId, setPOVId] = useState(null);
  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedValue(value);

    if (value) {
      const [field, dir] = value.split(" ");
      setSortField(field);
      setSortDir(dir);
    } else {
      setSortField(""); // Default sort
      setSortDir("");
    }
  };
  const safeValue = (value) => {
    return value === null || value === undefined || value === "" ? "-" : value;
  };

  const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const apiUrl = process.env.REACT_APP_API_URL;

  const [count, setCount] = useState(0);

  //filter
  const [sortByField, setSortByField] = useState("");
  const [sortBy, setSortBy] = useState("");

  const [selectedLocation, setSelectedLocation] = useState(null);

  const handleLocationChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedLocation(selectedOptions);
  };

  const [selectedVehicleType, setSelectedVehicleType] = useState(null);
  const handleVehicleTypeChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedVehicleType(selectedOptions);
    //setSelectedTransportLabels(selectedOptions.map((option) => option.value));
  };

  const [dockNumberOption, setDockNumberOption] = useState(null);

  const handleDockNumberDropdownChange = (option) => {
    console.log(option);
    setDockNumberOption(option);
  };

  const [dockType, setDockType] = useState("");

  const [dockTypeOptions, setDockTypeOptions] = useState([
    { label: "All", value: "" },
    { label: "Load In", value: "load_in" },
    { label: "Load Out", value: "load_out" },
  ]);
  const onSuccess = async (response) => {
    setShowCreateModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    getProductList();
  };
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const fromCreatedDate = startDate ? format(startDate, "yyyy-MM-dd") : "";
  const toCreatedDate = endDate ? format(endDate, "yyyy-MM-dd") : "";

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleReset = () => {
    setSelectedVehicleType(null);
    setDockNumberOption(null);
    setDockType("");
    setStartDate(null);
    setEndDate(null);
    setSelectedLocation(null);
    getProductList();
  };

  //filter over
  const [pageCount, setPageCount] = useState(0);

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("product");
  const [isModalVisible, setModalVisible] = useState(false);
  const [productList, setProductList] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [typeId, setTypeId] = useState(null);
  const [searchText, setSearchText] = useState("");

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterParams, setFilterParams] = useState({
    createdDate: "",
    sortBy: "",
    selectedUser: "",
    date: "",
  });

  const handleFilterApply = (filters) => {
    // Update sortBy state if it changed in filter
    if (filters.sortBy) {
      setSortBy(filters.sortBy);
    }

    setFilterParams({
      ...filters,
      date: filters.createdDate ? "" : filters.date,
      createdDate: filters.date ? "" : filters.createdDate,
    });
    setIsFilterOpen(false);
    setItemOffset(0);
  };

  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % productList.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(event.selected);
  }, []);

  useEffect(() => {
    getProductList();
  }, [
    itemsPerPage,
    itemOffset,
    searchText,
    sortField,
    sortDir,
    selectedLocation,
    dockNumberOption,
    dockType,
    selectedVehicleType,
    fromCreatedDate,
    toCreatedDate,
  ]);

  const openModal = () => {
    setTypeId(null);
    setShowCreateModal(true);
  };
  useEffect(() => {
    if (typeId != null) {
      setShowCreateModal(true);
    }
  }, [typeId]);

  const [selectedIds, setSelectedIds] = useState([]);

  const toggleSelectAll = () => {
    if (selectedIds.length === productList.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(productList.map((row) => row.id));
    }
  };
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const onSuccessVehicleType = async (response) => {
    setTypeId(null);
    setModalVisible(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    getProductList();
  };

  const getProductList = async () => {
    try {
      const response = await getProductListApi(
        `search=${searchText}&limit=${itemsPerPage}&skip=${
          itemOffset * itemsPerPage
        }&location_id=${
          selectedLocation ? selectedLocation.value : ""
        }&dock_id=${
          dockNumberOption ? dockNumberOption.value : ""
        }&dock_type=${dockType}&vehicletype_id=${
          selectedVehicleType ? selectedVehicleType.value : ""
        }&from_date=${fromCreatedDate}&to_date=${toCreatedDate}&sort_field=${sortField}&sort_dir=${sortDir}`
      );
      if (response.data.success === true) {
        setProductList(response.data.product_types);
        setPageCount(response.data.total_pgs);
        setCount(response.data.total_rec);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenBulkDelete, setIsOpenBulkDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const cancelDelete = () => {
    setDeleteId(null);
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setIsOpenDelete(false);
      getProductList();
    }
  };

  const FilterPanel = ({ isOpen, onClose, onApply, initialFilters }) => {
    const [localFilters, setLocalFilters] = useState({
      ...initialFilters,
      sortBy: initialFilters.sortBy || sortBy, // Sync with parent sortBy
    });

    const handleDateOptionChange = (value) => {
      setLocalFilters({
        ...localFilters,
        createdDate: value,
        date: "", // Clear specific date when date option is selected
      });
    };

    const handleSpecificDateChange = (event) => {
      setLocalFilters({
        ...localFilters,
        date: event.target.value,
        createdDate: "", // Clear date option when specific date is selected
      });
    };

    const handleFilterApply = (filters) => {
      // Update sortBy state if it changed in filter
      if (filters.sortBy) {
        setSortBy(filters.sortBy);
      }

      setFilterParams({
        ...filters,
        date: filters.createdDate ? "" : filters.date,
        createdDate: filters.date ? "" : filters.createdDate,
      });
      setIsFilterOpen(false);
      setItemOffset(0);
    };

    //filter css
    const styles = {
      container: {
        position: "fixed",
        top: 0,
        right: 0,
        transform: isOpen ? "translateX(0)" : "translateX(100%)",
        height: "100%",
        width: "320px",
        backgroundColor: "#fff",
        transition: "transform 0.3s ease-in-out",
        zIndex: 1000,
        fontFamily: "Epilogue",
      },
      panel: {
        padding: "5px 20px 5px 20px",
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
      },
      title: {
        fontSize: "18px",
        fontWeight: "700",
        fontFamily: "Epilogue",
        color: "#172B4D",
      },
      closeIcon: {
        background: "none",
        border: "1px solid #D4DDE7",
        borderRadius: "100px",
        padding: "8px",
        height: "40px",
        width: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      },
      sectionTitle: {
        fontSize: "16px",
        fontWeight: "700",
        fontFamily: "Epilogue",
        color: "#172B4D",
        marginBottom: "10px",
      },
      radioGroup: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        marginBottom: "11px",
      },
      radioLabel: (active) => ({
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "13px",
        fontFamily: "Epilogue",
        paddingTop: "8px",
        paddingBottom: "8px",
        fontWeight: 500,
        lineHeight: "100%",
        letterSpacing: "0%",
        verticalAlign: "middle",
        color: active ? "#D35258" : "#172B4D",
        cursor: "pointer",
      }),
      radioInput: (isActive) => ({
        width: "16px",
        height: "16px",
        border: "2px solid #D35258",
        borderRadius: "50%",
        background: isActive
          ? "radial-gradient(circle, #D35258 0%, #D35258 40%, transparent 41%)"
          : "#fff",
        cursor: "pointer",
        transition: "0.2s ease",
        display: "inline-block",
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "none",
        outline: "none",
      }),

      dateInput: {
        width: "100%",
        padding: "10px",
        height: "36px",
        borderRadius: "12px",
        border: "none",
        backgroundColor: "#FFE9EA",
        color: "#172B4D",
        fontSize: "13px",
        marginTop: "8px",
        outline: "none",
      },
      select: {
        width: "100%",
        height: "36px",
        padding: "10px",
        borderRadius: "12px",
        border: "1px solid #EBEBEB",
        fontSize: "13px",
        outline: "none",
      },
      modalFooter: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "30px",
      },
      resetButton: {
        padding: "10px 20px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: "#f0f0f0",
        color: "#001f3f",
        fontWeight: "bold",
        cursor: "pointer",
        fontSize: "13px",
      },
      applyButton: {
        padding: "10px 20px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: "#D35258",
        color: "#ffff",
        fontWeight: "bold",
        cursor: "pointer",
        fontSize: "13px",
      },
    };
  };

  const cancelBulkDelete = () => {
    setIsOpenBulkDelete(false);
  };
  const onSuccessBulkDelete = (response) => {
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setSelectedIds([]);
      setIsOpenBulkDelete(false);
      getProductList();
    }
  };
  const onFileResponse = (response) => {
    getProductList();
    console.log(response);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
  };

  return (
    <div className="customer-container mb-2">
      {isOpenDelete && (
        <DeleteModal
          deleteUrl={`${apiUrl}product_type/${deleteId}`}
          onSuccess={onSuccessDelete}
          onCancel={cancelDelete}
        />
      )}

      {showCreateModal && (
        <ProductCreateModal
          povId={typeId}
          onSuccess={onSuccess}
          onCancel={() => setShowCreateModal(false)}
        />
      )}
      <div className="customer-header">
        <div
          className="customer-back-button"
          onClick={() => {
            navigate(-1);
          }}
        >
          <img src={back} alt="Back" className="customer-backicon" />
        </div>
        <h1>Admin Setup</h1>
      </div>
      <div className="customer-card">
        <CustomerTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        <div className="top-bar flex flex-col md:flex-row md:items-center md:justify-between">
          <h2 className="title">
            {"Product Type"} ({count})
          </h2>

          <div className="action-group w-full md:w-auto">
            <div className="toolbar flex flex-col md:flex-row flex-wrap items-stretch">
              {/* Search Box */}
              <div className="search-box flex items-center border rounded-md w-full md:w-auto">
                <span className="icon mr-2">
                  <img
                    src={search}
                    alt="search"
                    className="search-icon w-4 h-4"
                  />
                </span>
                <input
                  type="text"
                  placeholder="Search"
                  className="outline-none w-full"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>

              {/* Sort Dropdown */}
              <button
                className="btn rounded-3 me-2"
                style={{ borderColor: "#dcdfe4" }}
              >
                <img src={df} />
                <select
                  style={{
                    outline: "none",
                    border: "none",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#172B4D",
                  }}
                  value={selectedValue}
                  onChange={handleChange}
                >
                  <option value="">Default (data created)</option>
                  <option value="name asc">Name (Asc)</option>
                  <option value="name desc">Name (Dsc)</option>
                  <option value="created asc">Date (Oldest)</option>
                  <option value="created desc">Date (Newest)</option>
                </select>
              </button>

              <CustomerButtons
                activeTab={activeTab}
                responseMsg={onFileResponse}
                isTemplate={true}
                isUpload={true}
                isDownload={true}
              />
              {/* Add Button */}
              <button
                onClick={openModal}
                className="addbtn bttn flex items-center  bg-blue-600 text-white rounded-md"
              >
                <span className="icon">
                  <img src={plus} alt="add" className="btn-icon w-4 h-4" />
                </span>
                Add
              </button>

              {selectedIds.length > 0 && (
                <button
                  className="addbtn bttn flex items-center bg-blue-600 text-white rounded-md"
                  onClick={() => {
                    setIsOpenBulkDelete(true);
                  }}
                >
                  {/* <span className="icon">
                  <img src={plus} alt="add" className="btn-icon w-4 h-4" />
                </span> */}
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="table-container">
          {activeTab === "product" && (
            <table className="dock-table">
              <thead>
                <tr>
                  <th>SI.No</th>
                  <th>Code</th>
                  <th>Product Name</th>
                </tr>
              </thead>
              <tbody>
                {productList?.map((row, index) => (
                  <tr key={"product" + index}>
                    <td>{itemOffset * itemsPerPage + (index + 1)}</td>
                    <td>{safeValue(row.code)}</td>
                    <td className="hover-time-cell group">
                      {safeValue(row.name)}
                      <div className="time-actions">
                        <button
                          onClick={(e) => {
                             e.stopPropagation();
                            setTypeId(row.id);
                            setShowCreateModal(true);
                          }}
                          className="icon-btn edit-btn"
                          title="Edit"
                        >
                          <img src={edit} alt="Edit" className="icon-img" />
                        </button>
                        <button
                          onClick={(e) => {
                             e.stopPropagation();
                            setDeleteId(row.id);
                          }}
                          className="icon-btn delete-btn"
                          title="Delete"
                        >
                          <img src={del} alt="Delete" className="icon-img" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Pagination */}
        <Row style={{ marginTop: "16px" }}>
          <Col>
            <div className="d-flex align-items-center justify-content-start mx-3">
              <span
                style={{
                  fontFamily: "Epilogue",
                  fontSize: "13px",
                  fontWeight: "500",
                  color: "#212129",
                }}
              >
                Records per page :
              </span>
              <select
                className="select3"
                id="perpage"
                value={itemsPerPage}
                onChange={(event) => {
                  setItemsPerPage(event.target.value);
                }}
                style={{
                  cursor: "pointer",
                  fontFamily: "Epilogue",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "18.9px",
                  color: "#212129",
                  width: "56px",
                  height: "24px",
                  borderRadius: "10px",
                  border: "0.7px solid #E5E5E5",
                  padding: "0 4px",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </Col>
          <Col>
            <div className="d-flex justify-content-end">
              <ReactPaginate
                previousLabel={<img src={lar} className="ar3" alt="previous" />}
                nextLabel={<img src={rar} className="ar3" alt="next" />}
                breakLabel={"..."}
                pageCount={pageCount + 1}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            </div>
          </Col>
        </Row>
        <div
          style={{
            textAlign: "center",
            marginTop: "30px",
            fontWeight: "400",
            fontSize: "12px",
            color: "#172B4D",
          }}
        >
          Powered by{" "}
          <span>
            <img src={mawalog} />
          </span>
        </div>
      </div>

      {/* Modal for VehicleAdd */}
      {/* {isModalVisible && <VehicleAdd typeId={typeId} onSuccess={onSuccessVehicleType} onClose={closeModal} />} */}
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      {isFilterOpen && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
          }}
        >
          <div
            className="modal-content"
            style={{
              position: "relative",
              width: "320px",
              height: "100%",
              marginLeft: "auto",
              backgroundColor: "#fff",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
            }}
          >
            <FilterPanel
              isOpen={isFilterOpen}
              onClose={() => setIsFilterOpen(false)}
              onApply={handleFilterApply}
              initialFilters={filterParams}
            />
          </div>
        </div>
      )}
    </div>
  );
}
